import React, { Component } from 'react'

import anime from 'animejs';

export default class Anime extends Component {
    componentDidMount(){
        const path = document.querySelectorAll("path#vn-id, path#vn-us, path#vn-afsel, path#vn-ru, path#vn-br, path#vn-aus, path#vn-ca");
        for (let i = 0; i < path.length; i++) {
            let pathEl = path[i];
            let offset = anime.setDashoffset(pathEl);
            let dur = 5000
            pathEl.setAttribute('stroke-dashoffset', offset);
            anime({
                targets: pathEl,
                strokeDashoffset: [offset, 0],
                duration: dur,//dur - (i * 1000), //anime.random(6000, 6000),
                delay: 1000 * i, //anime.random((1000 * i), (1000 * i))
                // delay: function(el, i, l) {
                //     return (i * 1000) - dur;
                // },
                // delay: anime.stagger(100),
                loop: true,
                direction: 'normal',
                easing: 'easeInOutExpo',
                autoplay: true
            });
        }
    }

    render() {
        return (
            <>
            </>
        )
    }

}
